import React, { createContext, useCallback, useContext, useMemo } from "react";
import { fetchProfile } from "./dmApi";

// Context unico per aprire un profilo pubblico completo.
// Non monta più il vecchio AuthorMiniProfile popup:
// delega la navigazione ad App.js tramite onOpenProfileById.

const MiniProfileCtx = createContext({ open: () => {} });
const DELETED_PROFILE_NAME = "Profilo eliminato";

export function MiniProfileProvider({
  children,
  onOpenProfileById,
}) {
  const open = useCallback(
    async (identityId) => {
      if (!identityId) return;

      try {
        const profile = await fetchProfile(identityId);

        if (profile?.displayName === DELETED_PROFILE_NAME) {
          return;
        }
      } catch {
        // Se il profilo non è caricabile qui,
        // lasciamo che la pagina profilo completa gestisca l'errore.
      }

      if (typeof onOpenProfileById === "function") {
        onOpenProfileById(identityId);
      }
    },
    [onOpenProfileById],
  );

  const ctxValue = useMemo(
    () => ({ open }),
    [open],
  );

  return (
    <MiniProfileCtx.Provider value={ctxValue}>
      {children}
    </MiniProfileCtx.Provider>
  );
}

export function useMiniProfile() {
  return useContext(MiniProfileCtx);
}
